import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getAllCheckInOutEmployeeTimeattendancereport = (query) => {
  return httpClient.get(
    server.REPORT_ALL + `/getallcheckinoutemployeetimeattendancereport`,
    query
  );
};

export const print_getAllCheckInOutEmployeeTimeattendancereport = (query) => {
  return httpClient.get(
    server.REPORT_ALL + `/print_getallcheckinoutemployeetimeattendancereport`,
    query
  );
};

export const print_getAllCheckInOutEmployeeActivityreport = (query) => {
  return httpClient.get(
    server.REPORT_ALL + `/print_getallcheckinoutemployeeavtivityreport`,
    query
  );
};

export const print_getAllClientWorkreport = (query) => {
  return httpClient.get(
    server.REPORT_ALL + `/print_getallclientworkreport`,
    query
  );
};

export const print_getAllDepartmentActivityreport = (query) => {
  return httpClient.get(
    server.REPORT_ALL + `/print_getalldepartmentactivityreport`,
    query
  );
};
